import { TabKeyType } from "../types";

export function setUserTypeChange(item: any, currentEmployee: any) {
  const { userType, labelInfoList } = item;
  if (userType) {
    return userType || "";
  }
  const app = item.app || item.appId;
  const teamId = item.teamId;
  let externalTag;
  let unCertifyYag;
  if (labelInfoList && labelInfoList.length > 0) {
    externalTag =
      labelInfoList.filter((item: any) => item.label === "isExternal" && item.isShow === "1")
        .length > 0;
    unCertifyYag =
      labelInfoList.filter((item: any) => item.label === "isUnCertify" && item.isShow === "1")
        .length > 0;
  } else {
    externalTag = false;
    unCertifyYag = false;
  }
  if (externalTag && app === currentEmployee.app && teamId === currentEmployee.teamId) {
    return "1";
  } else if (unCertifyYag && app === currentEmployee.app && teamId === currentEmployee.teamId) {
    return "2";
  } else if (app === currentEmployee.app && teamId !== currentEmployee.teamId) {
    return "4";
  } else if (app !== currentEmployee.app) {
    return "5";
  }

  return "3";
}

export function getDeptPositionDesc({
  deptName,
  titleName,
  userId,
  currentEmployee,
  unitName,
  userType
}: {
  deptName: string;
  titleName: string;
  userId?: string;
  currentEmployee?: any;
  unitName?: string;
  userType: string; // “1”：外部；  “2”：未认证； “3”：正式；  “4”：跨租户； “5”：跨平台；
}) {
  let desc;
  let e_dept_full_name: string = deptName;
  let e_position = titleName;
  // 唤起联系人选择器不显示当前账户自己的部门和岗位信息
  if (userId && currentEmployee && userId === currentEmployee.userId) {
    e_dept_full_name = currentEmployee.e_dept_full_name || "";
    e_position = currentEmployee.e_position || "";
  }
  if (userType === "1") {
    desc = e_position;
  } else if (e_dept_full_name?.includes("-")) {
    e_dept_full_name = e_dept_full_name.split("-").pop() || "";
    desc = e_dept_full_name + "-" + e_position;
  } else if (e_dept_full_name && !e_dept_full_name?.includes("-") && e_position) {
    desc = e_dept_full_name + "-" + e_position;
  } else if (!e_dept_full_name && e_position) {
    desc = e_position;
  } else if (e_dept_full_name && !e_position) {
    desc = e_dept_full_name + "-暂无岗位";
  } else {
    desc = "暂未填写";
  }
  desc = unitName && e_dept_full_name !== unitName ? unitName + "-" + desc : desc;
  // desc = unitName ? unitName + "-" + desc : desc;
  return desc;
}

export const handleContactData = (list: any = [], isDepContact = false) => {
  
  return list.map((item:any) => {
      return {avatar: item.avatar, 
          type: TabKeyType.Contact, 
          id: `${item.userId}_${item.teamId}`, 
          userId: item.userId, 
          teamId: item.teamId,
          name: item.nickName || item.realName,
          desc: item.desc || `${item.positionName}`,
          checked: false,
          labelInfoList: item.labelInfoList,
          isDepContact: isDepContact,
          highlight: item.highlight,
          descHighLight: item.descHighLight,
          keyHighLight: 'desc',
          keyTitleHighLight: 'realName',
          appId: item.app || item.appId,
      }
  })
}

export function convertEmployeeToString(employee: any): string {
  return `${employee.userId}:${employee.app || employee.appId}:${employee.teamId}`;
}

export function employeeToUid(employee: any) {
  return {
    app: employee?.app || employee.appId,
    pin: employee?.userId,
    teamId: employee?.teamId
  };
}

export function mapGroupMembersData(dataList: any, user:any) {
  return (dataList || []).map(
      (item: any) => {
        const userType = setUserTypeChange(item, {app: user.app_id, teamId: user.tenant_id});
          let fields: { [propName: string]: any } = {};
          (item.fields || []).forEach((fieldItem: any) => {
              fields[fieldItem.key] = fieldItem.val;
          });
          const isExternal = item?.labelInfoList.some((item: any) => item.isShow === '1' && item.labelEnum === 'EXTERNAL')
          let deptPositionDesc = getDeptPositionDesc(
             { unitName: item.mainTitleDeptInfo?.unitName || "",
             deptName: item.mainTitleDeptInfo?.deptName || "",
             titleName: item.mainTitleDeptInfo?.titleName || "", userType}
            )

          let desc = isExternal ? `外部联系人-${deptPositionDesc}` : deptPositionDesc;
          return {
              avatar: fields['avatar'] || '',
              app: item.appId,
              teamId: item.teamId,
              userId: item.userId,
              nickName: fields['name'] || '',
              realName: item.realName || '',
              desc,
              labelInfoList: item?.labelInfoList || [],
              type: TabKeyType.Contact,
              userType: item.userType
          };
      }
  );
}

let pinyin = require('js-pinyin');
const letters = '*abcdefghijklmnopqrstuvwxyz#'.split('');

export function groupListItem(list: any[]) {
    if ((list || []).length === 0) {
        return {};
    }

    const letterItemsMap: any = letters.reduce((result: any, letter) => {
        result[letter] = [];
        return result;
    }, {});
    const newList = list.map((item: any) => {
        return {
            ...item,
            pinName: pinyin.getFullChars(item.name).toLowerCase(),
        };
    });

    newList.sort((a, b) => a.pinName.localeCompare(b.pinName, 'zh')); // a~z 排序

    for (let item of newList) {
        let letter = item.pinName.charAt(0);
        if (!letters.includes(letter)) {
            letter = '#';
        }
        if (letterItemsMap.hasOwnProperty(letter)) {
            letterItemsMap[letter].push(item);
        } else {
            letterItemsMap[letter] = [item];
        }
    }
    let data:any = []
    for (let key in letterItemsMap) {
      const arr = letterItemsMap[key];
      if (!!arr.length) {
        arr[0].pinyin = key.toUpperCase()
        data = data.concat(arr);
      }
    }
    return data;
}